import "./LoonOpZandIntroductionTab.css";

export default function LoonOpZandIntroductionTab() {
  return (
    <div className="loonopzand-introduction">
      <section className="loonopzand-introduction__box" aria-labelledby="loonopzand-intro-title">
        <h2 id="loonopzand-intro-title">Introductie</h2>
        <p>
          Welkom op het Cliëntervaringsonderzoek Dashboard voor de Wmo-dienstverlening
          van de gemeente Loon op Zand.
        </p>
        <p>
          Dit dashboard geeft inzicht in de ervaringen van cliënten met de Wmo-dienstverlening
          in 2024 (Q4), 2025 (Q2 + Q4) en Q2 2026.
        </p>
        <p>
          De resultaten zijn gebaseerd op vier verschillende vragenlijsten die op
          verschillende momenten in het Wmo-proces aan cliënten zijn verstuurd.
          Door deze metingen kunnen we de ervaringen van cliënten volgen en de
          kwaliteit van onze dienstverlening blijven monitoren en verbeteren.
        </p>
        <p>De vier soorten vragenlijsten zijn als volgt:</p>
        <ol>
          <li>
            <strong>Vragenlijst kort na de aanvraag (1.1)</strong>
            <p>
              De vragenlijst werd verstuurd na afloop van het kwartaal waarin de hulp of
              ondersteuning was aangevraagd. We vroegen cliënten naar hun ervaring met
              het aanvraagproces om dit verder te kunnen verbeteren.
            </p>
          </li>
          <li>
            <strong>Vragenlijst na afloop van de beschikking (1.2)</strong>
            <p>
              Nadat de beschikking was afgelopen en een herindicatie of nieuwe beschikking
              nodig was, werd deze vragenlijst verstuurd in het aansluitende kwartaal.
              Het doel was om te onderzoeken of de verstrekte ondersteuning voldoende
              was en of er aanvullende behoeften waren.
            </p>
          </li>
          <li>
            <strong>Vragenlijst nadat ondersteuning is gestart (2)</strong>
            <p>
              Na het kwartaal wanneer de ondersteuning is gestart werd deze vragenlijst
              verstuurd. Hiermee werd gemeten hoe cliënten de ontvangen ondersteuning
              tot dat moment ervaarden.
            </p>
          </li>
          <li>
            <strong>Jaarlijkse vragenlijst voor langdurige ondersteuning (3)</strong>
            <p>
              Deze vragenlijst werd verstuurd naar cliënten die ten minste één jaar
              langdurige ondersteuning ontvingen. Het doel was om jaarlijks inzicht te
              krijgen in de tevredenheid en de ervaren effectiviteit van de ondersteuning.
              De vragenlijst wordt elk kwartaal uitgezet, zodat cliënten op een vast
              moment in hun ondersteuningsperiode kunnen worden bevraagd.
            </p>
          </li>
        </ol>
        <p>
          Vragenlijsten 1.1, 1.2 en 2 worden tweemaal per jaar verzonden (in Q2 en in Q4).
          Vragenlijst 3 wordt eenmaal per jaar verzonden (in Q4).
        </p>
        <p>
          De verzamelde gegevens geven waardevolle inzichten voor het verbeteren van de
          Wmo-diensten, zodat er beter ingespeeld kan worden op de wensen en behoeften
          van de cliënten.
        </p>
      </section>

      <section className="loonopzand-introduction__box" aria-labelledby="loonopzand-summary-title">
        <h2 id="loonopzand-summary-title">Samenvatting resultaten</h2>
        <p>
          In Q2 2026 namen 90 cliënten deel aan het onderzoek, verdeeld over drie
          vragenlijsten. In vergelijking met de eerdere cliëntervaringsonderzoeken is
          de respons op vragenlijst 1.1 hoger dan in Q4 2025 het geval was (in Q2 2026
          41%) en vergelijkbaar met vorige metingen. De respons op vragenlijst 1.2 is
          (licht) gedaald (29%), terwijl bij vragenlijst 2 een groei is te zien (44%).
        </p>
        <p>
          De gemiddelde beoordeling van de Wmo-dienstverlening kwam in Q2 2026 uit op
          een gemiddelde van 7,6. Hieruit blijkt dat cliënten over het algemeen tevreden
          zijn. De rapportcijfers per vragenlijst geven een iets genuanceerder beeld:
        </p>
        <ul>
          <li>
            Vragenlijst 1.1 werd in Q2 2026 gewaardeerd met een 7,8, een verbetering
            ten opzichte van 2025 toen de gemiddelde waardering een 7,5 was.
          </li>
          <li>
            Vragenlijst 1.2 werd in Q2 2026 eveneens gewaardeerd met een 7,8, wat
            vergelijkbaar is met de gemiddelde waardering van 7,7 in 2025.
          </li>
          <li>
            Vragenlijst 2 bleef met een lichte toename van 7,7 naar 7,8 vrijwel gelijk.
          </li>
        </ul>
        <p>
          De resultaten laten zien dat de waardering voor de Wmo-dienstverlening in
          Loon op Zand over het algemeen opnieuw positief is. Opvallend is de toegenomen
          waardering van cliënten die een nieuwe aanvraag hebben gedaan. De tevredenheid
          van cliënten met een herindicatie en van cliënten van wie de ondersteuning is
          gestart is constant gebleven.
        </p>
      </section>
    </div>
  );
}
